import React, { useState } from 'react'
import { Button, Container, Form, Modal } from 'react-bootstrap'

export const HaulierUnsupportedCountryModal = (props: {
  showModal: boolean
  setShowModal: (showModal: boolean) => void
}): React.ReactElement => {
  const { showModal, setShowModal } = props

  const [confirmedModal, setConfirmedModal] = useState(false)

  const handleClose = (): void => {
    setShowModal(false)
    setConfirmedModal(false)
  }

  const handleDone = (): void => {
    setConfirmedModal(true)
  }

  return (
    <Container>
      <Modal show={showModal} onHide={handleClose}>
        <div className="p-lg-4">
          {confirmedModal ? (
            <>
              <Modal.Header>
                <Modal.Title className="p-1 pt-3">
                  <b>Thanks a lot!</b>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>We will do our best to provide our services to you as soon as possible.</Modal.Body>
            </>
          ) : (
            <>
              <Modal.Header>
                <Modal.Title className="p-0">
                  <b>Sorry about this!</b>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-0 pb-3">
                Our services are not available in your country yet. You can choose to leave us your email, and we will inform you
                if something changes.
              </Modal.Body>
              <Form>
                <Form.Group className="form-group mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="name@example.com" autoFocus />
                </Form.Group>
              </Form>
              <Modal.Body className="p-0 pt-lg-5">
                If you have company in some of the available countries, you can always go back and continue sign up process.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleDone}>
                  Done
                </Button>
              </Modal.Footer>
            </>
          )}
        </div>
      </Modal>
    </Container>
  )
}
